<template>
  <div class="mb10">
    <table class="w-100">
      <tr class="bg-kplh-primary text-white">
        <td rowspan="2" class="col-1">NO</td>
        <td rowspan="2" class="col-5">PERSYARATAN</td>
        <td class="col-1">BOBOT</td>
        <td class="col-1">NILAI</td>
        <td rowspan="3" class="col-4">PENJELASAN HASIL PENILAIAN</td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td>{{ totalBobot }}</td>
        <!-- <td>{{ totalNilai }}</td> -->
        <td>{{ nilai }}</td>
      </tr>
      <!-- A -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">A</td>
        <td class="col-5">KEBIJAKAN, KEPEMIMPINAN & KOMITMEN</td>
        <td class="col-1">{{ bobot_a_1 }}</td>
        <td class="col-1">{{ componentAScore }}</td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan Kebijakan perusahaan tentang Keselamatan
          Pertambangan dan Lingkungan Hidup / Health, Safety & Environmental
        </td>
        <td class="col-1">{{ bobot_a_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_a_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_a_1', '') }}
        </td>
      </tr>
      <!-- B -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">B</td>
        <td class="col-5">MANAJEMEN RISIKO</td>
        <td class="col-1">{{ bobot_b_1 + bobot_b_2 + bobot_b_3 + bobot_b_4 }}</td>
        <td class="col-1">{{ componentBScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan prosedur yang mengatur proses manajemen risiko
        </td>
        <td class="col-1">{{ bobot_b_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil analisa risiko yang terakhir
        </td>
        <td class="col-1">{{ bobot_b_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan contoh tindak lanjut dari hasil analisa risiko.
          (Contoh: Hasil analisa risiko ditindaklanjuti dengan pembuatan
          prosedur atau dimasukkan dalam program kerja, dll.)
        </td>
        <td class="col-1">{{ bobot_b_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan 2 (dua) contoh salinan Analisa Keselamatan Kerja / JSA
        </td>
        <td class="col-1">{{ bobot_b_4 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">C</td>
        <td class="col-5">ORGANISASI DAN SUMBER DAYA</td>
        <td class="col-1">{{ bobot_e_1 }}</td>
        <td class="col-1">{{ componentCScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan struktur organisasi yang memiliki tanggung jawab KPLH
        </td>
        <td class="col-1">{{ bobot_e_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_1', '') }}
        </td>
      </tr>
      <!-- G -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">D</td>
        <td class="col-5">KOMUNIKASI</td>
        <td class="col-1">{{ bobot_g_2 + bobot_g_3 }}</td>
        <td class="col-1">{{ componentDScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan rapat KPLH (mis. Safety talk) yang dilakukan
          diperusahaan (minimal 3)
        </td>
        <td class="col-1">{{ bobot_g_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan kehadiran induksi KPLH kepada karyawan (minimal 2)
        </td>
        <td class="col-1">{{ bobot_g_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_3', '') }}
        </td>
      </tr>
      <!-- H -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">E</td>
        <td class="col-5">TANGGUNG JAWAB KPLH</td>
        <td class="col-1">{{ bobot_h_1 }}</td>
        <td class="col-1">{{ componentEScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan 3 salinan deskripsi pekerjaan / job desc karyawan
        </td>
        <td class="col-1">{{ bobot_h_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_h_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_h_1', '') }}
        </td>
      </tr>
      <!-- I -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">F</td>
        <td class="col-5">IMPLEMENTASI</td>
        <td class="col-1">{{ bobot_i2_2 + bobot_i2_3 + bobot_i52_1 + bobot_i7_2 + bobot_i8_1 + bobot_i8_3 + bobot_i9_2
          }}
        </td>
        <td class="col-1">{{ componentFScore }}</td>
        <td class="col-4"></td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">F.1</td>
        <td class="col-5">INSPEKSI</td>
        <td class="col-1">{{ bobot_i2_2 + bobot_i2_3 }}</td>
        <td class="col-1">{{ componentF1Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan program inspeksi tahun terakhir
        </td>
        <td class="col-1">{{ bobot_i2_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan salah satu rekomendasi hasil inspeksi dan bukti
          tindaklanjutnya
        </td>
        <td class="col-1">{{ bobot_i2_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_3', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-third">
        <td class="col-1">F.2</td>
        <td class="col-5">SARANA PRASARANA, INSTALASI & PERALATAN</td>
        <td class="col-1">{{ bobot_i52_1 }}</td>
        <td class="col-1">{{ componentF2Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar sarana, prasarana, instalasi dan peralatan (SPIP)
          yang dimiliki perusahaan.
        </td>
        <td class="col-1">{{ bobot_i52_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_1', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">F.3</td>
        <td class="col-5">PENGELOLAAN PERLINDUNGAN LINGKUNGAN</td>
        <td class="col-1">{{ bobot_i7_2 }}</td>
        <td class="col-1">{{ componentF3Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan dokumen izin lingkungan yang dimiliki perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i7_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i7_2', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">F.4</td>
        <td class="col-5">PROSEDUR KERJA</td>
        <td class="col-1">{{ bobot_i8_1 + bobot_i8_3 }}</td>
        <td class="col-1">{{ componentF4Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar seluruh prosedur pengendalian operasional yang
          dimiliki perusahaan (seluruh prosedur hingga Analisa Kerja Aman / JSA
          dan Instruksi Kerja Aman).
        </td>
        <td class="col-1">{{ bobot_i8_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan bukti sosialisasi prosedur pengendalian operasional
          kepada karyawan (minimal 3 bukti).
        </td>
        <td class="col-1">{{ bobot_i8_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_3', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">F.5</td>
        <td class="col-5">ALAT PELINDUNG DIRI</td>
        <td class="col-1">{{ bobot_i9_2 }}</td>
        <td class="col-1">{{ componentF5Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan daftar distribusi semua jenis APD, baik APD umum
          maupun APD khusus untuk pekerjaan tertentu.
        </td>
        <td class="col-1">{{ bobot_i9_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_2', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub text-white">
        <td class="col-1">G</td>
        <td class="col-5">STATISTIK KPLH</td>
        <td class="col-1">{{ bobot_k_2 }}</td>
        <td class="col-1">{{ componentGScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan penghargaan dalam bidang KPLH yang pernah didapatkan
          perusahaan.
        </td>
        <td class="col-1">{{ bobot_k_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_k_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_k_2', '') }}
        </td>
      </tr>

      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          HASIL PENILAIAN TOTAL UNTUK KATEGORI
          {{ kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-') }}
          <br>
          <span class="text-sm">**Nilai kelulusan adalah 75% atau lebih; di bawah itu, tidak memenuhi syarat untuk
            lulus</span>
        </td>
        <td class="text-center">{{ totalResult }} %</td>
        <!-- <td class="text-center">{{ finalScore }} %</td> -->
        <!-- <td class="text-center bg-success">LULUS PRAKUALIFIKASI</td> -->
        <td :class="`text-center ${finalResult && finalResult.indexOf('TIDAK') != -1
          ? 'bg-danger text-white'
          : 'bg-success'
          }`
          ">
          {{ finalResult }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          Catatan
        </td>
        <td colspan="2" class="text-center">{{ kplh && $get(kplh, 'request.kplh_penilaian.catatan', '-') }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    'kplh',
    'finalResult',
    'totalResult',
    'penilaian',
    'bobot',
    'totalNilai',
  ],
  data() {
    return {
      bobot_a_1: 2,
      bobot_b_1: 2,
      bobot_b_3: 3,
      bobot_b_4: 3,
      bobot_g_2: 2,
      bobot_g_3: 2,
      bobot_h_1: 4,
      bobot_i2_2: 2,
      bobot_i2_3: 2,
      bobot_i7_2: 2,
      bobot_i8_3: 3,
      bobot_k_2: 2,

      bobot_b_2: 2,
      bobot_e_1: 2,
      bobot_i52_1: 2,
      bobot_i8_1: 4,
      bobot_i9_2: 2,
    };
  },
  computed: {
    componentAScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_a_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_a_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentBScore() {
      let nilai = 0
      let bobot = 10
      let pertanyaan = 4
      this.penilaian.value_b_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_b_1)
      this.penilaian.value_b_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_b_2)
      this.penilaian.value_b_3 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_b_3)
      this.penilaian.value_b_4 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_b_4)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentCScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_e_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_e_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentDScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_g_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_g_2)
      this.penilaian.value_g_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_g_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentEScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 1
      this.penilaian.value_h_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_h_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentFScore() {
      const result = (Number(this.componentF1Score) + Number(this.componentF2Score) + Number(this.componentF3Score) + Number(this.componentF4Score) + Number(this.componentF5Score))
      return result.toFixed(2)
    },
    componentF1Score() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_i2_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i2_2)
      this.penilaian.value_i2_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i2_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentF2Score() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_i52_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i52_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * 2) / 3) / 1
      return nilai.toFixed(2)
    },
    componentF3Score() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_i7_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i7_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentF4Score() {
      let nilai = 0
      let bobot = 7
      let pertanyaan = 2
      this.penilaian.value_i8_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_i8_1)
      this.penilaian.value_i8_3 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i8_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentF5Score() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_i9_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i9_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentGScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_k_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_k_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },

    nilai() {
      const nilai = Number(this.componentAScore) + Number(this.componentBScore) + Number(this.componentCScore) + Number(this.componentDScore) + Number(this.componentEScore) + Number(this.componentFScore)

      return nilai.toFixed(2)
    },

    finalScore() {
      const nilai = this.totalResult
      // const nilai = (Number(this.nilai) / Number(this.totalBobot)) * 100
      return nilai.toFixed(2)
    },


    totalBobot() {
      this.penilaian.value_a_1 == 'N/A' ? this.bobot_a_1 = 0 : 0
      this.penilaian.value_b_1 == 'N/A' ? this.bobot_b_1 = 0 : 0
      this.penilaian.value_b_3 == 'N/A' ? this.bobot_b_3 = 0 : 0
      this.penilaian.value_b_4 == 'N/A' ? this.bobot_b_4 = 0 : 0
      this.penilaian.value_g_2 == 'N/A' ? this.bobot_g_2 = 0 : 0
      this.penilaian.value_g_3 == 'N/A' ? this.bobot_g_3 = 0 : 0
      this.penilaian.value_h_1 == 'N/A' ? this.bobot_h_1 = 0 : 0
      this.penilaian.value_i2_2 == 'N/A' ? this.bobot_i2_2 = 0 : 0
      this.penilaian.value_i2_3 == 'N/A' ? this.bobot_i2_3 = 0 : 0
      this.penilaian.value_i7_2 == 'N/A' ? this.bobot_i7_2 = 0 : 0
      this.penilaian.value_i8_3 == 'N/A' ? this.bobot_i8_3 = 0 : 0
      this.penilaian.value_k_2 == 'N/A' ? this.bobot_k_2 = 0 : 0

      this.penilaian.value_b_2 == 'N/A' ? this.bobot_b_2 = 0 : 0
      this.penilaian.value_e_1 == 'N/A' ? this.bobot_e_1 = 0 : 0
      this.penilaian.value_i52_1 == 'N/A' ? this.bobot_i52_1 = 0 : 0
      this.penilaian.value_i8_1 == 'N/A' ? this.bobot_i8_1 = 0 : 0
      this.penilaian.value_i9_2 == 'N/A' ? this.bobot_i9_2 = 0 : 0

      const total =
        this.bobot_a_1 +
        this.bobot_b_1 +
        this.bobot_b_3 +
        this.bobot_b_4 +
        this.bobot_g_2 +
        this.bobot_g_3 +
        this.bobot_h_1 +
        this.bobot_i2_2 +
        this.bobot_i2_3 +
        this.bobot_i7_2 +
        this.bobot_i8_3 +
        this.bobot_k_2 +
        this.bobot_b_2 +
        this.bobot_e_1 +
        this.bobot_i52_1 +
        this.bobot_i8_1 +
        this.bobot_i9_2

      return total
    }
  },
  mounted() {
    // do nothing
  }
}
</script>
